import {
    DashboardTitle
} from "./styled.js";

import ContainerAuthenticated from "containers/Authenticated";
import { Row, Col } from "reactstrap";
import FormReset from "../FormReset/index.js";

export default function ResetPassword(){  

    return ( 
        <>
            <ContainerAuthenticated page={"users/reset"}> 
                <Row>
                    <Col sm={12} md={8}>
                        <DashboardTitle>
                            Reset de senha
                        </DashboardTitle> 

                        <FormReset />

                    </Col>
                    <Col></Col>
                </Row>
            </ContainerAuthenticated> 
        </>
    );
}